module.exports = __webpack_public_path__ + "static/media/youtube.0f48d55e.png";